import { FeatureFlagMap } from '~/schemas/featureFlags'
import { nextApiClient } from './clients/nextApiClient'

export async function getActiveFeatureFlags(): Promise<FeatureFlagMap> {
  const { data } = await nextApiClient.get(`/feature-flags/active`)
  return data
}
